export var Breakpoint;
(function (Breakpoint) {
    Breakpoint[Breakpoint["xs"] = 0] = "xs";
    Breakpoint[Breakpoint["sm"] = 576] = "sm";
    Breakpoint[Breakpoint["md"] = 768] = "md";
    Breakpoint[Breakpoint["lg"] = 992] = "lg";
    Breakpoint[Breakpoint["xl"] = 1200] = "xl";
    Breakpoint[Breakpoint["xxl"] = 1440] = "xxl";
})(Breakpoint || (Breakpoint = {}));
